module.exports = __webpack_public_path__ + "img/wallet-2-line.5c94a4be.svg";